import {NO_NODE_ID} from 'common/src/components/CLCardsMap/CLCardsMap.config';
import _values from 'lodash/values';
import {Nodes} from 'common/src/modules/nodes/nodes.types';

export default function getAllUniqueRoots(nodes: Nodes): number[] {
  const treeRepresentation = getTreeArrayByInput(nodes);

  return treeRepresentation.map((inputArray, index) => {
    if (!inputArray || !inputArray.length) {
      return index;
    }
  });
}

function getTreeArrayByInput(nodes: Nodes) {
  const arrayRepresentation: Array<Array<number>> = [];

  _values(nodes).forEach((mapNode) => {
    if (!arrayRepresentation[mapNode.id]) {
      arrayRepresentation[mapNode.id] = [];
    }

    mapNode.inputs.forEach((input) => {
      input.node.id !== NO_NODE_ID && arrayRepresentation[mapNode.id].push(input.node.id);
    });
  });

  return arrayRepresentation;
}
